<template>
  <div>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Remove System Admin Form"
      id="admin_remove_account_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="admin_remove_admin_form_ref"
      id="admin_remove_admin_form"
      title="_"
      :is_loading="is_loading || (parseInt(system_user_id) == 1)"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_color="red"
      submit_btn_text="Remove"
    >
      
      <v-alert
        dense
        text
        type="error"
        v-if="parseInt(system_user_id) == 1"
      >
        Please note that this <strong>Super Admin Account Cannot Be Removed</strong>
      </v-alert>
      <div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">ID :</div>
          <b>#{{ system_user.id }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">First Name :</div>
          <b>{{ system_user.first_name }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">Last Name :</div>
          <b>{{ system_user.last_name }}</b>
        </div>
        <div class="text-left">
          <div class="inline wdth-150 text-left mr-10">Username :</div>
          <b>{{ system_user.email }}</b>
        </div>
      </div>
      <v-row no-gutterss class="pa-0 mb-0 pt-5">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.username"
            :validation_rules="form_validations.username"
            label="Enter System Users Login Username exactly "
            icon="mdi-pen-plus"
            :disabled="is_loading || (parseInt(system_user_id) == 1)"
          ></TextField>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminSystemAdminsDelete",
  components: {
    CardedSectionHeader,
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
    is_adding_admin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      system_user_id: 0,
      system_user: Utils.get_default_system_user(),
      errors: [],
      message: "",
      form: {
        username: "",
      },
      form_validations: {
        username: [
            Utils.validate.is_required("Users login username is required"),
            Utils.validate.email_format_or_phone(
                "Invalid input, must be a valid email address or a valid phone number"
            ),
        ],
      },
    };
  },
  methods: {
    load_system_user() {
      this.$emit("on-show-loader");
      ServerClient.Security.get_system_user(
        {
          id: this.system_user_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.system_user = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading system admin user on delete admin ",
            errors
          );
        }
      );
    },
    submit() {
        //check if this is equal
        if(this.form.username != this.system_user.email){
            this.errors = ["The entered username is not correct"];
            this.$refs.admin_remove_admin_form_ref.show_error_dialog();
            return false;
        }
        this.errors = [];
        this.message = "";
        this.$emit("on-show-loader");
        ServerClient.Security.remove_admin({
            id: this.system_user_id
        },(res) => {
            this.$emit("on-hide-loader");
            this.message =
            "<b>Admin rights have been removed</b>";
            this.$refs.admin_remove_admin_form_ref.show_message_dialog();
        },(errors) => {
            this.errors = errors;
            this.$refs.admin_remove_admin_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
        });
    },
    on_auto_fill() {
        this.form.username = this.system_user.email;
        this.errors =[];
        this.message = "";
    },
    on_hide_message() {
        this.$router.go(-1);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.system_user_id = parseInt(this.$route.params.id);

    this.$emit("set-page-attributes", {
      title: "Remove System Admin",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Users",
          disabled: false,
          href: "/admin/users",
        },
        {
          text: "Admins",
          disabled: false,
          href: "/admin/users/admin/list",
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/users/admin/list/"+ this.system_user_id +"/delete" ,
        },
      ],
    });
    this.load_system_user();
  },
};
</script>